<template>
    <div>
    </div>
    </template>
<script>
import axios from '../../../plugins/axios'
import utilitarios from '../../../plugins/utilitarios'
import impressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    modelo: ls.get('modeloimpressao'),
    relatorio: '',
    listEstudantfromPauta: [],
    html: ``
  }),
  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    },
    isModeloIMS () {
      return this.modelo.id == 2 ? ls.get('i_id') : 1
    },
    isHabilitado () {
      return !this.modelo
    }
  },
  watch: {
  },
  created  () {
    this.listEstudantfromPauta = this.$store.state.listEstudantfromPauta
    this.carregarRelatorio()
  },
  methods: {

    async carregarRelatorio () {
      try {
        this.relatorio = await axios.get('/obterRelatorioByDescricao/et').then(res => res.data)
        this.relatorio = this.relatorio.filter(r => r.idinstituicao == this.isModeloIMS)
        if (!this.relatorio.length) {
          this.$store.state.isloading = false
          Swal.fire({ icon: 'info', title: '', text: 'Lista nominal da turma não configurada!' })
        } else this.comporHTML()
      } catch (error) {
        this.sair()
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o relatório' })
      }
    },
    descricaoEscola () {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.listEstudantfromPauta[0].idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    getlogotipo () {
      let logotipoInstituto = ls.get('configuracoesReport').filter(c => c.chave === 'logotipo2')
      return (ls.get('isintegrado') === 0) ? ls.get('insignia') : (this.listEstudantfromPauta[0].idCurso <= 24 ? ls.get('logotipo') : (logotipoInstituto[0].valor))
    },
    comporHTML () {
      try {
        let declaracaoConfiguracoes = ls.get('configuracoesReport').filter(c => c.obs === 'Declaração')
        let directorConfiguracoes = ls.get('configuracoesReport').filter(c => c.chave === 'report' && c.obs === 'Certificado')

        /** Colocar em maiúscula as letras iniciais de cada palavra */
        directorConfiguracoes[3].valor = directorConfiguracoes[3].valor.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
          return a.toUpperCase()
        })

        this.html = this.relatorio[0].documento
        let documentoiter = this.relatorio[0].documentoiteracao1
        let header = this.relatorio[0].documentoiteracao2

        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
        this.html = this.html.replace(/{{insignia}}/g, this.getlogotipo())
        this.html = this.html.replace(/{{turma}}/g, this.listEstudantfromPauta[0].turma)
        this.html = this.html.replace(/{{curso}}/g, this.listEstudantfromPauta[0].curso)
        this.html = this.html.replace(/{{classe}}/g, this.listEstudantfromPauta[0].classe)
        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
        this.html = this.html.replace(/{{dataacual}}/g, utilitarios.correntDateByUnderstanding())

        let i = 1
        let dados = ``

        this.listEstudantfromPauta.forEach(element => {
          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{nomeAluno}}/g, element.nome.toUpperCase())
          iteracao = iteracao.replace(/{{matricula}}/g, element.idMatricula.toUpperCase())
          iteracao = iteracao.replace(/{{indice}}/g, i)
          dados += iteracao
          i++
        })
        this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
        this.html = this.html.replace(/{{dados}}/g, dados)
        header = header.replace(/{{siglaEFTSL}}/g, (this.listEstudantfromPauta[0].idCurso <= 24 ? (declaracaoConfiguracoes[1].valor.replace('nesta ', '')) : ''))
        header = header.replace(/{{director}}/g, (this.listEstudantfromPauta[0].idCurso <= 24 ? (directorConfiguracoes[3].valor) : ''))
        header = header.replace(/{{directorprofissao}}/g, (this.listEstudantfromPauta[0].idCurso <= 24 ? (directorConfiguracoes[4].valor) : ''))
        let options = { 'format': 'A4',
          'border': {
            'right': '12mm',
            'left': '12mm'
          },
          'header': {
            'height': '10mm',
            'contents': { first: header } },
          'footer': {
            'height': '10mm'

          } }
        impressao.htmlToPDF(this.html, options, ls.get('urlReport'), ls.get('idPessoa'))
      } catch (error) {
        console.log(error)
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao criar o PDF' })
        this.sair()
      } finally {
        this.$store.state.showDialogGuia.listaestudante = false
      }
    },

    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.listaestudante = false
    }
  }
}

</script>
